import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from './utils';

export interface LabelProps extends ComponentPropsWithoutRef<'label'> {
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { required, className, children, ...props },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn('text-sm font-medium text-zinc-900', className)}
      {...props}
    >
      {children}
      {required ? (
        <span className="ml-0.5 text-red-600" aria-hidden="true">
          *
        </span>
      ) : null}
    </label>
  );
});
